import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const companyRoutes: CustomRouteRecordRaw = {
  path: 'company',
  name: 'company',
  redirect: { name: 'companyUnvalidList' },
  component: EmptyLayout,
  meta: {
    title: '客户管理',
    iconfont: 'icon-user-settings-line',
    requiredPermission: 'company',
  },
  children: [
    {
      path: 'company-unvalid-list',
      name: 'companyUnvalidList',
      component: () => import('@/views/company/company-list.vue'),
      meta: {
        title: '待认证客户',
        requiredPermission: 'company.unvalid',
      },
      props: {
        status: [0, 2]
      }
    },
    {
      path: 'company-valid-list',
      name: 'companyValidList',
      component: () => import('@/views/company/company-list.vue'),
      meta: {
        title: '已认证客户',
        requiredPermission: 'company.valid'
      },
      props: {
        status: [1]
      }
    },
    {
      path: 'company-report-list',
      name: 'companyReportList',
      component: () => import('@/views/company/company-report.vue'),
      meta: {
        title: '客户数据报表',
        requiredPermission: 'company.report'
      },
    },
  ],
}
